import CommonConst from './Const';
import InitiateConst from './InitiateConstants';
import '../assets/fonts/fonts.css';
import Regex from './Regex';

export const Constants = {
  CommonConst,
  InitiateConst,
  Regex,
};
